












































export interface Image {
  height: number;
  width: number;
}
import Vue from "vue";
import { Messages } from "@/constants/messages";
export default Vue.extend({
  name: "FileUploader",
  data(): {
    allFiles: File[];
    mess: any;
    validFiles: File[];
    invalidFiles: boolean;
    deleting: boolean;
    errorMessage: string;
    image: Image;
  } {
    return {
      allFiles: [],
      validFiles: [],
      mess: Messages,
      invalidFiles: false,
      deleting: false,
      errorMessage: "",
      image: {
        height: 0,
        width: 0,
      },
    };
  },
  methods: {
    deleteValidFile(index: number) {
      this.validFiles.splice(index, 1);
    },
    async checkFile(file: File): Promise<boolean> {
      const validType = file.type === "image/png" || file.type === "image/jpeg";
      const MAX_SIZE_IMAGE = 3000 * 1000;
      const validSize = MAX_SIZE_IMAGE > file.size;
      if (!validType) {
        this.errorMessage = this.mess.error_extension + "PNG or JPEG.";
        return false;
      }
      if (!validSize) {
        this.errorMessage =
          this.mess.error_size_big + MAX_SIZE_IMAGE / 1000 + "KB.";
        return false;
      }
      return true;
    },
  },
  watch: {
    async allFiles(files: File[]) {
      if (files.length > 0) {
        this.invalidFiles = !(await this.checkFile(files[files.length - 1]));
        if (!this.invalidFiles) {
          this.validFiles.push(files[files.length - 1]);
        }
        files.pop();
      }
    },
    validFiles() {
      if (this.validFiles.length > 5) {
        this.validFiles.pop();
        this.errorMessage = this.mess.error_allowed__max + "5";
        this.invalidFiles = true;
      } else {
        if (this.validFiles.length < 5) {
          this.invalidFiles = false;
        }
        this.$emit("dropFiles", this.validFiles);
      }
    },
  },
});
